// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"239":"blog","443":"about"}[chunkId] + "." + {"239":"9aa41762","443":"7c6a0258"}[chunkId] + ".css";
};